import React from 'react';
import Error from 'src/svgs/status/exclamation.svg';
import {button, primary} from 'src/styles/modules/button.module.scss';
import {icon, errorHead, errorText, warn} from 'src/pages/reportIssue/components/styles.module.scss';

import PropTypes from 'prop-types';

export const ErrorScreen = ({
  scheduleCallbackUrl,
}) =>
  <>
    <Error className={`${icon} ${warn}`} />
    <h1 className={errorHead}>Looks like something went wrong</h1>
    <p className={errorText}>Schedule a callback to get help from one of our specialists.</p>
    <a className={`${button} ${primary}`} href={scheduleCallbackUrl}>Get a Call</a>
  </>;

ErrorScreen.propTypes = {
  scheduleCallbackUrl: PropTypes.string.isRequired,
};
